import axios from './api';
import Vue from 'vue';
const $cookie = require('vue-cookie');
class Session {
  set(name, value) {
    if (!name) return console.error('session参数错误！');
    let userObj = { name, value }
    let obj = { name: '', value: '' }
    let opt = {};
    Object.assign(opt, obj, userObj);

    if (typeof opt.value == "object") {
      opt.value = JSON.stringify(opt.value);
    }
    window.sessionStorage.setItem(opt.name, opt.value);
  }
  get(name) {
    let item = window.sessionStorage.getItem(name);
    if (!item) return item;
    try {
      item = JSON.parse(item);
    } catch (error) {
      item = item;
    }
    return item;
  }
  remove(name) {
    window.sessionStorage.removeItem(name);
  }
}

export let session = new Session();

export const deepCopy = data => JSON.parse(JSON.stringify(data));

export const orderByAd = (arr, key, sortDirection) => {
  /// <summary>按字段名排序</summary>
  /// <param name="key" type="String">排序的字段名</param>
  /// <param name="sortDirection" type="String">排序方向（ASC：升序， DESC：降序）, 默认升序</param>
  let newArr = deepCopy(arr);
  for (let i = 0; i < newArr.length - 1; i++) {
    let currentObj = newArr[i];
    if (typeof currentObj[key] != "undefined") {
      for (let j = i + 1; j < newArr.length; j++) {
        let nextObj = newArr[j];
        let currentValue = null;
        let nextValue = null;
        currentValue = currentObj[key];
        nextValue = nextObj[key];
        if (isNaN(Number(currentValue)) == false && isNaN(Number(nextValue)) == false) { //如果是数字则转换成数字来比较
          currentValue = Number(currentValue);
          nextValue = Number(nextValue);
        }

        let t_sortDirection = (sortDirection) ? sortDirection.toUpperCase() : "ASC";
        if (t_sortDirection == "ASC") {
          if (currentValue > nextValue) { //排序条件
            newArr[i] = nextObj;
            newArr[j] = currentObj;
            currentObj = newArr[i];
          }
        } else if (t_sortDirection == "DESC") {
          if (currentValue < nextValue) { //排序条件
            newArr[i] = nextObj;
            newArr[j] = currentObj;
            currentObj = newArr[i];
          }
        }
      }
    }
  }
  return newArr;
}

export const clearAllCookie = () => {
  let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (let i = keys.length; i--;) {
      var exp = new Date();
      exp.setTime(exp.getTime() - 1000); //过去时间
      if (keys[i].indexOf('notification_close_') == -1 && keys[i].indexOf('pcx_cp_close') == -1) {
        // document.cookie = keys[i] + "=0;expires=" + exp.toGMTString() + ";path=/;" + (location.href.indexOf(".pingcexue.com") != -1 ? "domain=.pingcexue.com" : "")
        document.cookie = keys[i] + "=0;expires=" + exp.toGMTString() + ";path=/;" + `domain=${window.__domain__}`
        document.cookie = keys[i] + "=0;expires=" + exp.toGMTString();
      }
    }
  }

  session.remove('user');
  session.remove('role');
}

export const loginFromUser = (num, psd) => {
  axios('client.userLoginCheck', {
    userName: num,
    password: psd,
    userExtent: null
  }).then(r => {
    // console.log(r);

  });
}

export const loginFromAdmin = (num, psd, callback) => {
  axios('ManagerUsers.loginManagerUsers', {
    user: {
      userNumber: num,
      userPassword: psd
    }
  }).then(r => {
    // console.log(r);
    if (r.code !== '000') {
      Vue.prototype.$message({
        type: 'error',
        message: r.msg
      });
      return;
    }
    Vue.prototype.get_simpleUser = r.user;
    /**
     * ~ roleFlag true 是管理员 false 是 代理商
     */
    session.set('role', { roleFlag: true, roleId: '1' });
    session.set('user', r.user);
    return callback(r);
  });
}

export const getUrlParams = () => {
  let args = new Object();
  let query = location.hash.split('?')[1]; //获取查询串
  let pairs = query.split("&"); //在逗号处断开

  for (let i = 0; i < pairs.length; i++) {
    let pos = pairs[i].indexOf('='); //查找name=value
    if (pos == -1) continue; //如果没有找到就跳过
    let argName = pairs[i].substring(0, pos); //提取name
    let value = pairs[i].substring(pos + 1); //提取value
    args[argName] = unescape(value); //存为属性
  }
  return args;
}

class FullLoad {
  constructor() {
    this.loading = null;
  }
  load() {
    this.loading = hv.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  close() {
    this.loading.close();
  }
}

export let fullLoad = new FullLoad();

//获取某一年的某一个月有多少天
export function getDays(year, month) {
  let days = [31,28,31,30,31,30,31,30,30,31,30,31]
  if ( (year % 4 ===0) && (year % 100 !==0 || year % 400 ===0) ) {
        days[1] = 29
  }
  return days[month-1];
}

/**
 * @description 根据options配置重组数据
 * @property { arr: Array } arr
 * @property { options: Object } options
 * @returns { result: Array }
 */
export function reorganizeCampusDataForSelect(arr, options = { labelKey: 'id', valueKey: 'label'}){
  let result = []
  const { valueKey, labelKey } = options
  arr.forEach(e => {
    let tempObj = {}
    tempObj[labelKey] = e[labelKey]
    tempObj[valueKey] = e[valueKey]
    result.push(tempObj)
  });
  // console.log('result,', result);
  return result
}

/**
 * 防抖函数封装
 * @param {Function} func 需要防抖的函数
 * @param {number} [wait=250] 延迟时间（毫秒）
 * @param {boolean} [immediate=false] 是否立即执行
 * @returns {Function} 返回防抖处理后的函数（含cancel方法）
 */
export function debounce(func, wait = 250, immediate = false) {
  let timeout = null

  // 封装防抖核心逻辑
  function debounced(...args) {
    const context = this

    // 清除已有定时器
    if (timeout) clearTimeout(timeout)

    // 立即执行逻辑
    if (immediate) {
      const callNow = !timeout
      timeout = setTimeout(() => {
        timeout = null
      }, wait)
      if (callNow) return func.apply(context, args)
    }

    // 延迟执行逻辑
    timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }

  // 添加取消方法
  debounced.cancel = () => {
    clearTimeout(timeout)
    timeout = null
  }

  return debounced
}



// WEBPACK FOOTER //
// ./src/utils/tool.js